import { Link } from "react-router-dom";
import { FaXTwitter, FaInstagram, FaFacebookF, FaTelegram, FaYoutube } from "react-icons/fa6";

const COLS = [
  { title: "Products", links: [["Spot Trading", "/trade"], ["Futures", "/futures"], ["Trading Bots", "/copy-trading"], ["Prediction Market", "/prediction-market"], ["Earn", "/earn"], ["FutureChain Card", "/wallet"], ["NFT", "/nft"]] },
  { title: "Company", links: [["About", "/about"], ["Blog", "/blog"], ["Careers", "/about"], ["Newsroom", "/blog"], ["Contact", "/contact"]] },
  { title: "Resources", links: [["API Docs", "/api"], ["Help Center", "/help"], ["Fees", "/pricing"], ["Roadmap", "/about"], ["Downloads", "/help"]] },
  { title: "Legal", links: [["Terms of Service", "/help"], ["Privacy Policy", "/help"], ["AML Policy", "/help"], ["Cookies", "/help"], ["Risk Disclosure", "/help"]] },
];

const SOCIAL = [
  { Icon: FaXTwitter, href: "https://x.com/futurechain_", label: "FutureChain on X" },
  { Icon: FaInstagram, href: "https://www.instagram.com/futurechain_official?igsh=Zm15MmNvYzRkMnho", label: "FutureChain on Instagram" },
  { Icon: FaFacebookF, href: "https://www.facebook.com/profile.php?id=61593264352115", label: "FutureChain on Facebook" },
  { Icon: FaTelegram, href: "https://t.me/futurechain01", label: "FutureChain on Telegram" },
  { Icon: FaYoutube, href: "https://www.youtube.com/@FutureChain-e2z", label: "FutureChain on YouTube" },
];
const isExternal = (url) => typeof url === "string" && /^(https?:)?\/\//i.test(url);

export default function Footer() {
  return (
    <footer className="relative bg-surface-soft border-t border-ink-100 mt-24" data-testid="site-footer">
      <div className="container-x section-x pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 flex flex-col gap-6">
            <Link to="/" className="inline-flex items-center">
              <img src={`${process.env.PUBLIC_URL}/logo-b.png`} alt="FutureChain" className="w-auto object-contain" style={{ maxHeight: '64px' }} />
            </Link>
            <p className="text-sm text-ink-500 leading-relaxed max-w-sm">
              AI-powered, secure, and transparent crypto trading — built to make digital finance simple, accessible, and rewarding for everyone.
            </p>
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-600">
              Linking Today, Building Tomorrow
            </p>
            <div className="flex flex-wrap items-center gap-2">
              {SOCIAL.map(({ Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${i}`}
                  aria-label={label}
                  className="w-9 h-9 rounded-full bg-white border border-ink-100 flex items-center justify-center text-ink-500 hover:text-brand-600 hover:border-brand-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <div className="font-display font-semibold text-ink-900 text-sm mb-4">{c.title}</div>
                <ul className="flex flex-col gap-2.5">
                  {c.links.map(([label, to]) => (
                    <li key={label}>
                      {isExternal(to) ? (
                        <a
                          href={to}
                          data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-ink-500 hover:text-brand-600"
                        >
                          {label}
                        </a>
                      ) : (
                        <Link
                          to={to}
                          data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="text-sm text-ink-500 hover:text-brand-600"
                        >
                          {label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="hairline my-8" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-ink-500">
            © {new Date().getFullYear()} FutureChain. All rights reserved.
          </div>
          <div className="text-xs text-ink-400 font-mono">
            v3.11 · 142 countries · Uptime 99.99%
          </div>
        </div>
      </div>
    </footer>
  );
}
